import BillingsCargoTaxiUpdateRequest, {
  BillingsCargoTaxiUpdateRequestBody,
} from "./billings-cargo-taxi-update.request";

const createBody = (
  request: BillingsCargoTaxiUpdateRequest,
): BillingsCargoTaxiUpdateRequestBody => {
  return {
    billingNodes: request.billingNodes,
    billingContributions: request.billingContributions,
  };
};

const billingsCargoTaxiUpdateRequestFactory = {
  createBody,
};

export default billingsCargoTaxiUpdateRequestFactory;
